import React, {useEffect, useState} from 'react';
import {View, Modal, FlatList, Platform} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import Header from '../../elements/Header';
import Text from '../../elements/Text';
import Checkbox from '../../elements/Checkbox';
import Divider from '../../elements/Divider';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES} from '../../../utils/Constants';
import Button from '../../elements/Button';
import {Container} from '../FilterProductsModal';
import {useDisableBodyScroll} from '../../../hooks/use-disable-dody-scroll';
import {tID} from '../../../utils/TestIdHelper';
import {CloseIcon} from '../../../utils/SvgIcons';

const FilterResourceModal = ({
  visible,
  onClose,
  onApplyFilter,
  selectedFilters,
  onResetFilter,
  tags,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [selectedTags, setSelectedTags] = useState(selectedFilters);
  const insets = useSafeAreaInsets();

  //hook to disable scrolling for web
  useDisableBodyScroll(visible);

  useEffect(() => {
    setSelectedTags(selectedFilters);
  }, [selectedFilters]);

  const onPressCheckbox = item => {
    let tempSelected = [...selectedTags];
    let index = tempSelected.indexOf(item);
    if (index == -1) {
      tempSelected.push(item);
    } else {
      tempSelected.splice(index, 1);
    }

    setSelectedTags(tempSelected);
  };

  const renderTagListItem = ({item, index}) => {
    return (
      <Checkbox
        selected={selectedTags.includes(item)}
        key={index}
        title={item.name}
        topMargin={16}
        titleStyle={styles.checkboxTitle}
        onPress={() => onPressCheckbox(item)}
        checkboxStyle={styles.checkboxStyle}
      />
    );
  };

  return (
    <Modal
      testID={tID('FilterResourceModal-Modal-Main')}
      visible={visible}
      animationType="slide"
      onRequestClose={onClose}
      transparent={Platform.OS === 'web'}>
      <Container onClose={onClose}>
        <View
          testID={tID('FilterResourceModal-View-HeaderContainer')}
          style={styles.headerComponent}>
          <Header
            title={
              Platform.OS === 'web' ? 'Filter Resources' : 'Filter Options'
            }
            leftImage={<CloseIcon />}
            leftIconAccessibilityLabel="Close"
            onPressLeftIcon={onClose}
          />
        </View>
        <View style={styles.container}>
          <Text
            variation="Body1SemiBold"
            color={colors.textPrimary}
            topMargin={24}>
            Selected Categories{' '}
            <Text
              testID={tID('FilterResourceModal-Text-CategoriesCount')}
              variation="Body1Regular"
              color={colors.textPrimary}>
              ({selectedTags.length})
            </Text>
          </Text>
          <FlatList
            data={tags}
            renderItem={renderTagListItem}
            showsVerticalScrollIndicator={false}
            keyExtractor={(item, index) => index}
            ItemSeparatorComponent={() => <Divider top={16} />}
            contentContainerStyle={styles.pb24}
          />
          <View
            style={[
              styles.buttonsContainer,
              {paddingBottom: insets.bottom + 8},
            ]}>
            <Button
              testID={tID('FilterResourceModal-Button-Reset')}
              title={'Reset'}
              buttonType={BUTTON_TYPES.Bordered}
              style={styles.leftButton}
              onPress={onResetFilter}
            />
            <Button
              testID={tID('FilterResourceModal-Button-Apply')}
              title={'Apply'}
              disabled={selectedTags.length === 0}
              titleColor={colors.textOnAccent}
              buttonType={BUTTON_TYPES.Filled}
              style={styles.rightButton}
              onPress={() => onApplyFilter(selectedTags)}
            />
          </View>
        </View>
      </Container>
    </Modal>
  );
};

export default FilterResourceModal;
